import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { backButton } from '@tma.js/sdk'

/**
 * Wires the TG mini-app `BackButton` to react-router.
 *
 * When the BackButton is visible inside Telegram, the system back gesture
 * (swipe from edge on iOS, hardware back on Android) triggers the
 * button's click instead of closing the mini-app. So as soon as the user
 * is anywhere but the root, we show it and route the click to
 * `navigate(-1)` — giving back-swipe the obvious meaning of "go back one
 * screen". On the root, we hide it; back gesture closes the app, which
 * is what users expect there.
 *
 * Mount this once inside AppShell.
 */
export function BackButtonSync() {
  const location = useLocation()
  const navigate = useNavigate()

  // Mount the BackButton component once on first render. backButton.mount()
  // is idempotent and required before show/hide work.
  useEffect(() => {
    if (!backButton.isSupported()) return
    backButton.mount()
    return () => backButton.unmount()
  }, [])

  // Show on non-root, hide on root; rebind click handler each route.
  useEffect(() => {
    if (!backButton.isSupported() || !backButton.isMounted()) return
    if (location.pathname === '/') {
      backButton.hide()
      return
    }
    backButton.show()
    const offClick = backButton.onClick(() => navigate(-1))
    return () => {
      offClick()
    }
  }, [location.pathname, navigate])

  return null
}
